// @ts-check
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { isUrlValid } from 'utils';
import { NO_IMAGE_AVAILABLE } from 'constants/index';

/**
 * @typedef {Object} ImageProps
 * @property {string} src
 * @property {string} alt
 * @property {string} [fallback]
 * @property {'NM' | 'BG'} [userBrand]
 */

/** @param {ImageProps & React.ImgHTMLAttributes} props */
const Image = ({ src, alt, fallback, userBrand, ...rest }) => {
  const fallbackURL = NO_IMAGE_AVAILABLE[userBrand];
  const sanitizedURL = isUrlValid(src) ? src : fallbackURL;
  const onError = (e) => {
    e.target.src = fallback || fallbackURL;
  };
  return <img src={sanitizedURL} alt={alt} onError={onError} {...rest} />;
};

Image.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  fallback: PropTypes.string,
  userBrand: PropTypes.oneOf(['NM', 'BG']),
};

Image.defaultProps = {
  alt: '',
  userBrand: 'NM',
};

export default memo(Image);
